import { useEffect } from 'react'

/**
 * Hook to enforce clean, neutral public styling on all public-facing pages.
 * Ensures user themes (e.g. solarized-light, dark-pro, etc.) chosen in student/admin
 * portals never leak onto marketing, directory, or blog pages.
 */
export function usePublicPage() {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const root = document.documentElement
    // Enforce default clean light baseline on public pages
    root.setAttribute('data-theme', 'glass-light')
    root.classList.remove('dark')
    root.classList.add('light')

    // Remove any inline custom properties previously applied by portal theme engine
    root.removeAttribute('style')

    // Mark portal attribute as public
    document.body.setAttribute('data-portal', 'public')
    document.body.classList.remove('bg-background')
    document.body.classList.add('bg-white')
  }, [])
}
